import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: black;
`
export const ContainerItems = styled.div`
  padding: 80px 80px 80px 150px;
  width: calc(100vw - 200px);
  margin-left: 200px;
`
